const RunEnum = Object.freeze({
  // 測試機
  Debug: 0,

  // 正式機
  Release: 1,
  // 安新測試機
  DebugForAnn: 2,
  // 安新雲端測試機 UAT
  UAT: 3,
  // 正月ut測試機
  JTC_UT: 4,
  // 正月DEV 開發站
  JTC_DEV: 5,
});

var hostList = {};

// Debug: 連測試站 , Release:連正式站

const runType = RunEnum.Release;

hostList["runType"] = runType;

hostList["version"] = "1.6.32";

// 台新E2EE key
hostList["plaintext"] = "dDIMn97pv9yTMGjeiowVfezvDTwIlijW";
hostList["plaintext2"] = "If1S507m3Il2pOaw";

if (runType == RunEnum.Debug) {
  // 測試站
  hostList["PRIVATE_HOST"] = "https://anshinescrow-dev.januarytc.com";
  hostList["WEB_HOST"] = "https://anshinescrow-dev.januarytc.com";
  // hostList["OCR_HOST"] = "http://192.168.1.16/OCR_API";
} else if (runType == RunEnum.DebugForAnn) {
  // 安新測試站
  hostList["PRIVATE_HOST"] = "http://192.168.8.136";
  hostList["WEB_HOST"] = "http://192.168.8.136";
} else if (runType == RunEnum.UAT) {
  // 安新UAT 測試站
  hostList["PRIVATE_HOST"] = "http://23.102.235.181";
  hostList["WEB_HOST"] = "http://23.102.235.181";
} else if (runType == RunEnum.JTC_UT) {
  hostList["PRIVATE_HOST"] = "https://anshinescrow-dev.januarytc.com";
  hostList["WEB_HOST"] = "https://anshinescrow-dev.januarytc.com";

  // hostList["plaintext"] = "";
  // hostList["plaintext2"] = "";
} else if (runType == RunEnum.JTC_DEV) {
  hostList["PRIVATE_HOST"] = "https://anshinescrow-dev.januarytc.com";
  hostList["WEB_HOST"] = "https://anshinescrow-dev.januarytc.com";
} else if (runType == RunEnum.Release) {
  // 正式站
  hostList["PRIVATE_HOST"] = "https://webintra.anshinescrow.com";
  hostList["WEB_HOST"] = "https://www.anshinescrow.com";
  // 中繼站網址
  // hostList["OCR_HOST"] = "http://192.168.1.16/OCR_API";
  /*
   API-Key A碼 
   金鑰雜湊 B碼
  */
  hostList["plaintext"] = "jk6tcjOEsQRAHUX9YovIbmpOwn83rSaH";
  hostList["plaintext2"] = "Em6Gq3vquWd26V6y";
}

// 檢查是否為測試機
hostList.checkHost = function () {
  if (
    hostList["PRIVATE_HOST"]?.indexOf("dev") != -1 ||
    hostList["PRIVATE_HOST"]?.indexOf("192.168.8.136") != -1 ||
    hostList["PRIVATE_HOST"]?.indexOf("23.102.235.181") != -1
  ) {
    // 測試機
    return 0;
  } else {
    return 1;
  }
};
hostList.runType = runType;

export default hostList;
